import _, { filter } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { Box, Button, Flex } from "rebass";
import { LoadingFrame } from "../components/common/LoadingFrame";
import { DoorDetailSummary } from "../components/order/DoorDetailSummary";
import { OrderDetail } from "../components/order/OrderDetail";
import { OrderDetailSwap } from "../components/order/OrderDetailSwap";
import { ToastMessage } from "../components/order/ToastMessage";
import Tick from "../icons/Tick";
import { MainLayout } from "../layouts/MainLayout";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import {
  systemActions,
  yodaCatalogueActions,
  yodaCustomerActions,
  yodaIdentityActions,
  yodaOrdersActions,
  yodaMessageActions,
} from "../logic/actions";
import { getLocalizedString } from "../utils";
import config from "../utils/globalConfig";
import SendOrderView from "../components/order/SendOrderView";
import { yodaOrdersService } from "../logic/services";
import SummaryTableRow from "../components/cart/SummaryTableRow";
import useResponsive from "../hooks/useResponsive";
import OrderData from "../components/order/OrderData";
import OrderTabs from "../components/order/OrderTabs";
import SwitchSwap from "../components/common/SwitchSwap";
import Tooltip from "../components/common/Tooltip";
import useGuardCustomerRoute from "../hooks/useGuardCustomerRoute";
import useOrderType from "../hooks/useOrderType";
import ConfigurationCheck from "../components/order/ConfigurationCheck";
import { ReactComponent as ReportIcon } from "../static/images/icona_PDF.svg";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { usePrevious } from "@react-hookz/web";
import CannotOrderMessage from "../components/order/CannotOrderMessage";
import SelectOrderEmail from "../components/order/SelectOrderEmail";
import useGtmCheckoutTracker from "../hooks/analytics/useGtmCheckoutTracker";

const OrderDetailsPage = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const navigate = useHistory();
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { tab } = useSelector((state) => state.system);
  const { configuration, error, orderDetails, orderRowDetails } = useSelector(
    (state) => state.yodaOrders,
  );
  const { catalogueItemDetails, catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { me } = useSelector((state) => state.yodaStakeholders);

  const history = useHistory();

  const [resetted, setResetted] = useState(false);
  const [expanded, setExpanded] = useState(1);
  const [expandedCheck, setExpandedCheck] = useState(0);
  const [switchOrderMessage, setSwitchOrderMessage] = useState();
  const [showInfo, setShowInfo] = useState(false);
  const [showSendOrderView, setShowSendOrderView] = useState(false);

  const [order, setOrder] = useState(null);
  const [selectedEmails, setSelectedEmails] = useState([
    { label: "gpapa@alteanet.it", value: "gpapa@alteanet.it" },
  ]); // TODO: GTM TEST - rimuovere

  const [removedProduct, setRemovedProduct] = useState([]);
  const { shippingCost } = useSelector((state) => state.yodaOrders);

  const { isMobile, breakpoint } = useResponsive();

  useGuardCustomerRoute({ matchOrder: true });

  const { isSwapEnabledForOrder } = useOrderType();

  useGtmCheckoutTracker();

  const prevDetails = usePrevious(catalogueItemDetails);
  const prevDetailsSwap = usePrevious(catalogueItemDetailsSwap);
  const preRowDetails = usePrevious(orderRowDetails);

  const showEmailSelect = order?.customData?.changeRecipient;

  const getProductIdentifier = (product) =>
    `${product?.productId}_${product?.type}`;
  const removeProduct = (product) => {
    const newRemoved = [...removedProduct, getProductIdentifier(product)];
    setRemovedProduct(newRemoved);
  };

  const calculateShippingCost = (shippingArray) =>
    shippingArray
      ?.map((shipping) => shipping.shippingCost)
      .reduce((a, b) => a + b, 0) || 0;

  useEffect(() => {
    if (
      orderId &&
      (!_.isEqual(catalogueItemDetailsSwap, prevDetailsSwap) ||
        !_.isEqual(catalogueItemDetails, prevDetails))
    ) {
      reloadOrder(orderId);
    }
  }, [
    catalogueItemDetailsSwap,
    prevDetailsSwap,
    catalogueItemDetails,
    prevDetails,
    orderId,
  ]);

  useEffect(() => {
    dispatch(
      yodaMessageActions.getMessages(localStorage.getItem("selectedCustomer")),
    );

    return () => {
      dispatch(yodaMessageActions.clearMessages());
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(yodaOrdersActions.resetOldOrder());
      dispatch(systemActions.setTab(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reloadOrder = (orderId) => {
    return yodaOrdersService.getOrderById(orderId).then((res) => {
      setOrder(res);
      return res;
    });
  };

  const orderTypeReorder = config.ORDER_TYPE_REORDER;
  const orderTypeSwap = config.ORDER_TYPE_SWAP;

  useEffect(() => {
    if (orderDetails && customer) {
      if (orderDetails.length == 0) {
        setResetted(true);
      }
      if (
        orderDetails.length > 0 &&
        !!configuration?.length &&
        order &&
        resetted
      ) {
        setResetted(false);
        const seasonId = order.seasonId;
        const catalogReorderIds = [
          ...new Set(
            orderDetails
              ?.filter((o) => o.type === "REORDER")
              .map((o) => o.catalogId),
          ),
        ];
        const catalogSwapIds = [
          ...new Set(
            orderDetails
              ?.filter((o) => o.type === "SWAP")
              ?.map((o) => o.catalogId),
          ),
        ];
        catalogReorderIds.forEach((id) => {
          dispatch(
            yodaCatalogueActions.getOneCatalog(customer?.id, id, seasonId),
          );
        });
        catalogSwapIds.forEach((id) => {
          dispatch(
            yodaCatalogueActions.getOneCatalogSwap(customer?.id, id, seasonId),
          );
        });
      }
    }
    if (order && document) {
      document.orderTypeId = order.orderTypeId;
    }
  }, [orderDetails, customer, configuration, order, tab]);

  useEffect(() => {
    if (order?.orderTypeId && tab === null)
      dispatch(
        systemActions.setTab(
          order.orderTypeId == config.ORDER_TYPE_SWAP ? 1 : 0,
        ),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order?.orderTypeId]);

  useEffect(() => {
    dispatch(yodaOrdersActions.orderReset(orderId));
    dispatch(yodaIdentityActions.getColors());
    dispatch(
      yodaCustomerActions.getOne(localStorage.getItem("selectedCustomer")),
    );

    window.addEventListener("keydown", handleKeyPress);
    window.addEventListener("collapsed", handleCollapse);
    if (document) {
      document.externalPinPadHandle = {};
    }
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("collapsed", handleCollapse);
      if (document) {
        document.externalPinPadHandle = undefined;
        document.orderTypeId = undefined;
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener("switchOrderRequest", switchOrder);

    return () => {
      window.removeEventListener("switchOrderRequest", switchOrder);
    };
  }, [orderRowDetails]);

  useEffect(() => {
    if (orderId && !_.isEqual(orderRowDetails, preRowDetails))
      dispatch(yodaOrdersActions.getOrderShippingCost(orderId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderRowDetails, preRowDetails]);

  function switchOrder(event) {
    if (
      document?.orderTypeId == config.ORDER_TYPE_SWAP &&
      filter(
        orderRowDetails,
        (rowDetail) => rowDetail.customData.typeId == config.ORDER_TYPE_SWAP,
      ).length > 0
    ) {
      setSwitchOrderMessage(getLocalizedString("SWITCH_ORDER"));
    } else {
      dispatch(yodaOrdersActions.switchOrder(orderId));
      setTimeout(() => {
        reloadOrder(orderId).then((res) => {
          if (document) {
            document.orderTypeId = res.orderTypeId;
          }
          if (res.orderTypeId == config.ORDER_TYPE_SWAP) {
            dispatch(systemActions.setTab(1));
          } else {
            dispatch(systemActions.setTab(0));
          }
        });
      }, 1000);
    }
  }

  function handleCollapse(evt) {
    let tmpValue = expandedCheck;
    if (evt.detail.expand) {
      setExpandedCheck(expandedCheck + 1);
      tmpValue = tmpValue + 1;
    } else {
      setExpandedCheck(expandedCheck - 1);
      tmpValue = tmpValue - 1;
    }

    if (tmpValue <= 0) {
      setExpanded(0);
    } else {
      setExpanded(1);
    }
  }

  function getOrderDetailArrayFiltered() {
    if (orderRowDetails) {
      let tabItems = [];
      const productIds = [];
      const type =
        tab === 0 ? config.ORDER_TYPE_REORDER : config.ORDER_TYPE_SWAP;
      if (tab === 0) {
        Object.keys(catalogueItemDetails).forEach((k) => {
          const withValues = catalogueItemDetails[k].catalog?.filter(
            (c) => c.quantity > 0,
          );
          if (withValues.length > 0) {
            productIds.push(k);
          }
        });
      } else {
        Object.keys(catalogueItemDetailsSwap).forEach((k) => {
          if (
            catalogueItemDetailsSwap[k].catalog?.filter((c) => c.quantity > 0)
              .length > 0
          ) {
            productIds.push(k);
          }
        });
      }
      productIds
        ?.filter(
          (pi) =>
            !removedProduct.includes(
              getProductIdentifier({ productId: Number(pi), type }),
            ),
        )
        .forEach((id, i) => {
          const cItem =
            tab === 0 ? catalogueItemDetails[id] : catalogueItemDetailsSwap[id];
          tabItems.push({
            productId: cItem.productId,
            modelCode: cItem.modelCode,
            collectionCode: cItem.collectionCode,
            line: cItem.lineCode,
            collection: cItem.collectionDescription,
            type,
            images: cItem.catalog,
          });
        });

      return tabItems.sort((a, b) => (a.modelCode > b.modelCode ? 1 : -1));
    }
    return [];
  }

  function getOrderTotals() {
    if (orderRowDetails) {
      let orderItems = [];
      Object.entries(catalogueItemDetails).forEach(([productId, item]) => {
        if (
          item.catalog?.some((c) => c.quantity > 0) &&
          !removedProduct.includes(getProductIdentifier(item))
        ) {
          orderItems.push({
            productId: item.productId,
            modelCode: item.modelCode,
            collectionCode: item.collectionCode,
            line: item.lineCode,
            collection: item.collectionDescription,
            type: config.ORDER_TYPE_REORDER,
          });
        }
      });

      Object.entries(catalogueItemDetailsSwap).forEach(([productId, item]) => {
        if (
          item.catalog?.some((c) => c.quantity > 0) &&
          !removedProduct.includes(getProductIdentifier(item))
        ) {
          orderItems.push({
            productId: item.productId,
            modelCode: item.modelCode,
            collectionCode: item.collectionCode,
            line: item.lineCode,
            collection: item.collectionDescription,
            type: config.ORDER_TYPE_SWAP,
          });
        }
      });
      return orderItems.sort((a, b) => (a.modelCode > b.modelCode ? 1 : -1));
    }
    return [];
  }

  function handleKeyPress(event) {
    if (event.keyCode == 9) {
      event.preventDefault();
      let focusedPadIndex = -1;
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads.length; ++index) {
        if (numericPads[index].style.display == "block") {
          focusedPadIndex = index;
        }
      }
      let i = (focusedPadIndex + 1) % numericPads.length;
      if (numericPads[i] !== undefined) {
        numericPads[i].click();
      }
    }
    if (event.key == "Enter") {
      event.preventDefault();
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads.length; ++index) {
        if (numericPads[index].style.display == "block") {
          numericPads[index].blur();
        }
      }
    }
    if (event.keyCode == 187) {
      event.preventDefault();
      let el = document.querySelector(".valueUp");
      if (el) {
        el.click();
      }
    }
    if (event.keyCode == 189) {
      event.preventDefault();
      let el = document.querySelector(".valueDown");
      if (el) {
        el.click();
      }
    }
  }

  function calculatedColors(id, type) {
    let colorGroups = {};
    const item =
      type === config.ORDER_TYPE_SWAP
        ? catalogueItemDetailsSwap?.[id]
        : catalogueItemDetails?.[id];
    item?.catalog?.forEach((catalogItem) => {
      const identifier = `${catalogItem.colorCode}_${type}`;
      if (colorGroups[identifier] === undefined) {
        colorGroups[identifier] = {
          colorDescription: catalogItem.colorDescription["it"],
          rgb: catalogItem.rgb,
          code: catalogItem.colorCode,
          catalogId: catalogItem.catalogId,
          values: [
            {
              size: catalogItem.size,
              sizeCode: catalogItem.sizeRowId,
              quantity: catalogItem.quantity,
            },
          ],
        };
      } else {
        colorGroups[identifier].values.push({
          size: catalogItem.size,
          sizeCode: catalogItem.sizeRowId,
          quantity: catalogItem.quantity,
        });
      }
    });
    if (colorGroups === undefined) {
      return [];
    }

    let tmpArr2 = Object.values(colorGroups);

    return Array.from(tmpArr2);
  }

  let totalQuantityReorder = 0;
  let totalPriceReorder = 0;
  let totalQuantitySwap = 0;
  let totalPriceSwap = 0;

  let totalQuantityDoorReorder = {};
  let totalPriceDoorReorder = {};

  let totalQuantityDoorSwap = {};
  let totalPriceDoorSwap = {};

  let totalQuantityCollectionReorder = {};
  let totalPriceCollectionReorder = {};

  let totalQuantityCollectionSwap = {};
  let totalPriceCollectionSwap = {};

  let totalQuantityColorReorder = {};
  let totalPriceColorReorder = {};

  let totalQuantityColorSwap = {};
  let totalPriceColorSwap = {};

  let collectionMapReorder = {};
  let collectionMapSwap = {};

  let alreadyCalculated = [];

  getOrderTotals().forEach((item) => {
    calculatedColors(item.productId, item.type).map((catalogItem) => {
      order?.customData?.doors?.map((doorId) => {
        let catalogId = catalogItem.catalogId;
        let orderItems = filter(
          orderRowDetails,
          (orderRow, v) =>
            orderRow.catalogId === catalogId &&
            item.type === orderRow?.customData?.typeId,
        );
        orderItems.forEach((orderItem) => {
          let fullCode = orderItem?.fullCode?.split("_");
          if (fullCode && fullCode.length > 0) {
            let colorCode = fullCode[fullCode.length - 1];
            let collectionCode = fullCode[1];
            let lineId = orderItem?.id;

            if (
              orderItem?.customData?.doorId === doorId &&
              colorCode == catalogItem.code &&
              !alreadyCalculated.includes(lineId)
            ) {
              alreadyCalculated.push(lineId);
              if (item.type === orderTypeReorder) {
                totalQuantityReorder += orderItem.currentQuantity;
                totalPriceReorder += orderItem.price;

                if (totalQuantityDoorReorder[doorId] == undefined) {
                  totalQuantityDoorReorder[doorId] = orderItem.currentQuantity;
                } else {
                  totalQuantityDoorReorder[doorId] += orderItem.currentQuantity;
                }

                if (totalPriceDoorReorder[doorId] == undefined) {
                  totalPriceDoorReorder[doorId] = orderItem.price;
                } else {
                  totalPriceDoorReorder[doorId] += orderItem.price;
                }

                if (totalQuantityCollectionReorder[doorId] === undefined) {
                  totalQuantityCollectionReorder[doorId] = {};
                }

                if (totalPriceCollectionReorder[doorId] === undefined) {
                  totalPriceCollectionReorder[doorId] = {};
                }

                if (totalQuantityColorReorder[item.productId] === undefined) {
                  totalQuantityColorReorder[item.productId] = {};
                }
                if (totalPriceColorReorder[item.productId] === undefined) {
                  totalPriceColorReorder[item.productId] = {};
                }

                if (collectionMapReorder[collectionCode] === undefined) {
                  collectionMapReorder[collectionCode] = item.collection;
                }

                if (
                  totalQuantityCollectionReorder[doorId][collectionCode] ==
                  undefined
                ) {
                  totalQuantityCollectionReorder[doorId][collectionCode] =
                    orderItem.currentQuantity;
                } else {
                  totalQuantityCollectionReorder[doorId][collectionCode] +=
                    orderItem.currentQuantity;
                }

                if (
                  totalPriceCollectionReorder[doorId][collectionCode] ==
                  undefined
                ) {
                  totalPriceCollectionReorder[doorId][collectionCode] =
                    orderItem.price;
                } else {
                  totalPriceCollectionReorder[doorId][collectionCode] +=
                    orderItem.price;
                }

                if (
                  totalQuantityColorReorder[item.productId][catalogItem.code] ==
                  undefined
                ) {
                  totalQuantityColorReorder[item.productId][catalogItem.code] =
                    orderItem.currentQuantity || 0;
                } else {
                  totalQuantityColorReorder[item.productId][catalogItem.code] +=
                    orderItem.currentQuantity || 0;
                }

                if (
                  totalPriceColorReorder[item.productId][catalogItem.code] ==
                  undefined
                ) {
                  totalPriceColorReorder[item.productId][catalogItem.code] =
                    orderItem.price;
                } else {
                  totalPriceColorReorder[item.productId][catalogItem.code] +=
                    orderItem.price;
                }
              }

              if (item.type === orderTypeSwap) {
                totalQuantitySwap += orderItem.currentQuantity;
                totalPriceSwap += orderItem.price;

                if (totalQuantityDoorSwap[doorId] == undefined) {
                  totalQuantityDoorSwap[doorId] = orderItem.currentQuantity;
                } else {
                  totalQuantityDoorSwap[doorId] += orderItem.currentQuantity;
                }

                if (totalPriceDoorSwap[doorId] == undefined) {
                  totalPriceDoorSwap[doorId] = orderItem.price;
                } else {
                  totalPriceDoorSwap[doorId] += orderItem.price;
                }

                if (totalQuantityCollectionSwap[doorId] === undefined) {
                  totalQuantityCollectionSwap[doorId] = {};
                }
                if (totalPriceCollectionSwap[doorId] === undefined) {
                  totalPriceCollectionSwap[doorId] = {};
                }

                if (totalQuantityColorSwap[item.productId] === undefined) {
                  totalQuantityColorSwap[item.productId] = {};
                }
                if (totalPriceColorSwap[item.productId] === undefined) {
                  totalPriceColorSwap[item.productId] = {};
                }

                if (collectionMapSwap[collectionCode] === undefined) {
                  collectionMapSwap[collectionCode] = item.collection;
                }

                if (
                  totalQuantityCollectionSwap[doorId][collectionCode] ==
                  undefined
                ) {
                  totalQuantityCollectionSwap[doorId][collectionCode] =
                    orderItem.currentQuantity;
                } else {
                  totalQuantityCollectionSwap[doorId][collectionCode] +=
                    orderItem.currentQuantity;
                }

                if (
                  totalPriceCollectionSwap[doorId][collectionCode] == undefined
                ) {
                  totalPriceCollectionSwap[doorId][collectionCode] =
                    orderItem.price;
                } else {
                  totalPriceCollectionSwap[doorId][collectionCode] +=
                    orderItem.price;
                }

                if (
                  totalQuantityColorSwap[item.productId][catalogItem.code] ==
                  undefined
                ) {
                  totalQuantityColorSwap[item.productId][catalogItem.code] =
                    orderItem.currentQuantity;
                } else {
                  totalQuantityColorSwap[item.productId][catalogItem.code] +=
                    orderItem.currentQuantity;
                }

                if (
                  totalPriceColorSwap[item.productId][catalogItem.code] ==
                  undefined
                ) {
                  totalPriceColorSwap[item.productId][catalogItem.code] =
                    orderItem.price;
                } else {
                  totalPriceColorSwap[item.productId][catalogItem.code] +=
                    orderItem.price;
                }
              }
            }
          }
        });
      });
    });
  });

  function expand() {
    if (expanded == 0) {
      let tmpList = document.getElementsByClassName("checvron.exp_false");
      for (let index = 0; index < tmpList.length; ++index) {
        let element = tmpList[index].parentNode.parentNode;
        element.click();
      }
    } else {
      let tmpList = document.getElementsByClassName("checvron.exp_true");
      for (let index = 0; index < tmpList.length; ++index) {
        let element = tmpList[index].parentNode.parentNode;
        element.click();
      }
    }
    setExpanded(expanded == 0 ? 1 : 0);
  }

  function sendOrder() {
    dispatch(
      yodaOrdersActions.transmitOrder(
        {
          orderId: order.id,
          recipients: selectedEmails.map((option) => option.value),
        },
        () => {
          reloadOrder(orderId).then((res) => {
            if (isMobile && res?.status == "WaitingForConfirmation")
              setShowSendOrderView(true);
          });
        },
      ),
    );
  }

  if (me?.error === "not-authorized") {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: true,
          },
        }}
      />
    );
  }
  return (
    <MainLayout>
      <LoadingFrame order={true}></LoadingFrame>
      <ToastMessage
        message={
          error &&
          error.message &&
          error.message.replaceAll(" , ", "\r\n").replaceAll(", ", "\r\n")
        }
        confirmFunction={() => {
          dispatch(yodaOrdersActions.resetError());
        }}
        style={{ width: 600 }}
      />
      <ToastMessage
        message={switchOrderMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(yodaOrdersActions.switchOrder(orderId));
          setSwitchOrderMessage(null);
          setTimeout(() => {
            reloadOrder(orderId).then((res) => {
              dispatch(systemActions.setTab(0));
            });
          }, 1000);

          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setSwitchOrderMessage(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600, fontSize: "0.8em" }}
      />
      <ConfigurationCheck
        message={<CannotOrderMessage />}
        buttonLabelCode="ORDER_PAGE_BACK_BUTTON"
        confirmFunction={() => {
          history.push("/orders/" + order?.stakeholderId);
        }}
      />
      <Box
        sx={{
          backgroundColor: "#fff",
        }}
      >
        <OrderData
          actions={
            <Link
              to={"/orderReport/" + order?.id}
              onClick={(e) => {
                e.stopPropagation();
              }}
              sx={{ pointer: "cursor" }}
            >
              <Tooltip content={getLocalizedString("REPORT")}>
                <Box>
                  <ReportIcon width={32} height={32} />
                </Box>
              </Tooltip>
            </Link>
          }
          {...{ order, customer, showInfo, setShowInfo }}
        />

        {/* TABS */}
        {order && order.status != "WaitingForConfirmation" && (
          <Flex
            sx={{
              position: "relative",
            }}
            width={1}
            maxWidth={config.VIEWPORT}
          >
            {isMobile ? (
              <Flex
                justifyContent="space-between"
                alignItems="center"
                bg="#a2a2a2"
                width={1}
                height={55}
              >
                <Flex>
                  <Flex
                    ml="5px"
                    px={2}
                    bg={tab == 0 ? "white" : ""}
                    color={tab == 0 ? "" : "white"}
                    alignItems="center"
                    justifyContent="center"
                    height={40}
                    style={{
                      fontSize: "10px",
                      top: "8px",
                      position: "relative",
                    }}
                    onClick={() => {
                      if (tab == 1) {
                        dispatch(systemActions.setTab(0));
                      }
                    }}
                  >
                    {getLocalizedString("REORDER")}
                  </Flex>
                  {order?.orderTypeId == orderTypeSwap && (
                    <Flex
                      px={2}
                      bg={tab == 1 ? "white" : ""}
                      color={tab == 1 ? "" : "white"}
                      alignItems="center"
                      justifyContent="center"
                      height={40}
                      style={{
                        fontSize: "10px",
                        top: "8px",
                        position: "relative",
                      }}
                      onClick={() => {
                        if (tab == 0) {
                          dispatch(systemActions.setTab(1));
                        }
                      }}
                    >
                      {getLocalizedString("SWAP_TAB")}
                    </Flex>
                  )}
                </Flex>

                <Flex alignItems={"center"} pr="10px">
                  {isSwapEnabledForOrder() && (
                    <>
                      <Box
                        fontSize="12px"
                        color="white"
                        sx={{ cursor: "pointer", mr: "4px" }}
                        onClick={() => {
                          dispatchEvent(
                            new CustomEvent("switchOrderRequest", {
                              bubbles: true,
                            }),
                          );
                        }}
                      >
                        {order?.orderTypeId === config.ORDER_TYPE_SWAP
                          ? getLocalizedString("SWITCH_SWAP_HIDE")
                          : getLocalizedString("SWITCH_SWAP")}
                      </Box>
                      <SwitchSwap
                        variant="contained"
                        enableRedirect={
                          order?.orderTypeId === config.ORDER_TYPE_REORDER
                        }
                      />
                    </>
                  )}
                  <Box
                    onClick={expand}
                    sx={{
                      "& > svg > g > g > line": { stroke: "white" },
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      mx: "5px",
                    }}
                  >
                    <Box bg="#a2a2a2">
                      {expanded ? (
                        <BsChevronUp size="24px" color="white" />
                      ) : (
                        <BsChevronDown size="24px" color="white" />
                      )}
                    </Box>
                  </Box>
                </Flex>
              </Flex>
            ) : (
              <OrderTabs
                expandable={true}
                isExpanded={expanded}
                enableRedirect={
                  order?.orderTypeId === config.ORDER_TYPE_REORDER
                }
                catalogueTab={tab}
                setCatalogueTab={(tab) => dispatch(systemActions.setTab(tab))}
                {...{ expand }}
              />
            )}
          </Flex>
        )}
        {/* END - TABS */}
      </Box>

      {/* ORDER ITEMS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {order &&
        order.status != "WaitingForConfirmation" &&
        getOrderDetailArrayFiltered().map((e, idx) => {
          if (e.type == config.ORDER_TYPE_REORDER) {
            return (
              <React.Fragment key={e?.productId}>
                <OrderDetail
                  totalQuantityColorMap={
                    totalQuantityColorReorder[e?.productId]
                  }
                  id={e?.productId}
                  modelCode={e?.modelCode}
                  collectionCode={e?.collectionCode}
                  line={e?.line}
                  collection={e?.collection?.it}
                  expandAll={expanded}
                  images={e?.images}
                  callbackRemoved={() => removeProduct(e)}
                ></OrderDetail>
              </React.Fragment>
            );
          }
          if (e.type == config.ORDER_TYPE_SWAP) {
            return (
              <React.Fragment key={e?.productId}>
                <OrderDetailSwap
                  totalQuantityColorMap={totalQuantityColorSwap[e?.productId]}
                  type={e.type}
                  key={e?.productId}
                  id={e?.productId}
                  seasonCode={e?.seasonCode}
                  modelCode={e?.modelCode}
                  articleCode={e?.materialCode}
                  collectionCode={e?.collectionCode}
                  line={e?.line}
                  collection={e?.collection?.it}
                  images={e?.images}
                  expandAll={expanded}
                  callbackRemoved={() => removeProduct(e)}
                ></OrderDetailSwap>
              </React.Fragment>
            );
          }
          return null;
        })}

      {getOrderDetailArrayFiltered().length === 0 && (
        <Flex
          flexDirection={"column"}
          justifyContent={"center"}
          sx={{
            marginTop: "10px",
            minHeight: "150px",
            gap: "10px",
          }}
        >
          <Flex justifyContent={"center"}>
            {getLocalizedString("Carrello vuoto 1")}
          </Flex>
          <Flex justifyContent={"center"}>
            {getLocalizedString("Carrello vuoto 2")}
          </Flex>
        </Flex>
      )}

      {orderRowDetails && orderRowDetails.length == 0 && (
        <LoadingFrame order={true}></LoadingFrame>
      )}
      {/* END - ORDER ITEMS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}

      {/* CART SUMMARY +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {order && order.status == "Draft" && (
        <Flex
          width={1}
          mt={3}
          p={breakpoint([".5em 0 2em", 4])}
          style={{
            backgroundColor: "#646464",
          }}
          flexDirection="column"
        >
          {/* TABLE HEADER */}
          <SummaryTableRow
            disableFormatting
            {...{
              name: getLocalizedString("CART SUMMARY"),
              qty: getLocalizedString("QTA"),
              price: getLocalizedString("TOTALE"),
              sx: { background: "#a1a1a1", color: "#fff", fontSize: ".9em" },
            }}
          />
          <Box style={{ height: 1 }} width={1} backgroundColor="#878787"></Box>
          {/* ROWS */}
          <Flex
            width={1}
            flexDirection={"column"}
            style={{
              color: "#fff",
            }}
          >
            {order?.customData?.doors?.map((e, i) => {
              return (
                <DoorDetailSummary
                  key={`order-door-${i}-${e}`}
                  doorCode={e}
                  collectionMap={collectionMapReorder}
                  quantityDetails={totalQuantityCollectionReorder?.[e]}
                  priceDetails={totalPriceCollectionReorder?.[e]}
                  doorQuantity={totalQuantityDoorReorder?.[e]}
                  doorPrice={totalPriceDoorReorder?.[e]}
                  defaultExpanded={
                    i === 0 && order?.customData?.doors?.length === 1
                  }
                  reorder={{
                    collectionMap: collectionMapReorder,
                    quantityDetails: totalQuantityCollectionReorder?.[e],
                    priceDetails: totalPriceCollectionReorder?.[e],
                    doorQuantity: totalQuantityDoorReorder?.[e],
                    doorPrice: totalPriceDoorReorder?.[e],
                  }}
                  swap={
                    order?.orderTypeId === orderTypeSwap
                      ? {
                          collectionMap: collectionMapSwap,
                          quantityDetails: totalQuantityCollectionSwap?.[e],
                          priceDetails: totalPriceCollectionSwap?.[e],
                          doorQuantity: totalQuantityDoorSwap?.[e],
                          doorPrice: totalPriceDoorSwap?.[e],
                        }
                      : null
                  }
                ></DoorDetailSummary>
              );
            })}
          </Flex>
          {/* TOTAL */}
          <SummaryTableRow
            total
            {...{
              name: getLocalizedString("TotalOrder"),
              qty: totalQuantityReorder + totalQuantitySwap,
              price:
                totalPriceReorder -
                totalPriceSwap +
                calculateShippingCost(shippingCost),
              sx: { background: "#a1a1a1", color: "#fff", marginTop: "20px" },
              totalActions: isMobile ? null : (
                <SelectOrderEmail
                  {...{ order, selectedEmails, setSelectedEmails }}
                  sx={{
                    mr: "2em",
                    /*visibility: "hidden",*/
                  }}
                />
              ),
            }}
          />
          {isMobile && (
            <Box sx={{ flex: 1, padding: "32px 10px 10px" }}>
              <SelectOrderEmail
                {...{ order, selectedEmails, setSelectedEmails }}
                sx={{
                  color: "black",
                  /*visibility: "hidden",*/
                }}
              />
            </Box>
          )}
        </Flex>
      )}
      {/* END - CART SUMMARY +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}

      {order && order.status == "WaitingForConfirmation" && (
        <Flex
          width={1}
          mt={3}
          p={4}
          style={{
            backgroundColor: "#F2F2F2",
          }}
          flexDirection={["column"]}
        >
          <Flex
            mt={3}
            width={1}
            style={{
              color: "#fff",
            }}
            justifyContent="center"
            mb={20}
          >
            <Flex
              justifyContent={"center"}
              alignItems="center"
              width={25}
              height={25}
              style={{
                borderRadius: 100,
                backgroundColor: "#464646",
              }}
            >
              <Tick style={{ width: 14 }} />
            </Flex>
            <Flex alignItems="center" ml={3} color={"#232323"} fontSize={14}>
              {getLocalizedString("ORDINE INVIATO CORRETTAMENTE")}
            </Flex>
          </Flex>
        </Flex>
      )}

      {/* BUTTONS */}
      {order?.status === "Draft" && (
        <Flex
          width={1}
          height={["160px", "auto"]}
          py={[0, "2rem"]}
          bg={["#303130", "transparent"]}
          justifyContent="center"
          flexDirection={["column", "row"]}
          style={{ gap: "20px" }}
          mb="-9px"
        >
          <Flex justifyContent="center">
            <Button
              variant="primary"
              sx={{
                minWidth: [100, 200, 300],
                fontFamily: "Open Sans",
                fontSize: "0.8em",
                fontWeigth: 800,
                color: ["#000", "#fff"],
                width: "220px",
                background: ["#fff", "#646464"],
                textTransform: "uppercase",
              }}
              onClick={() => {
                navigate.push("/catalogue/" + order.id);
              }}
            >
              {getLocalizedString("BACK TO CATALOGUE")}
            </Button>
          </Flex>
          <Flex justifyContent="center">
            <Button
              variant="primary"
              sx={{
                minWidth: [100, 200, 300],
                fontFamily: "Open Sans",
                fontSize: "0.8em",
                fontWeigth: 800,
                color: ["#000", "#fff"],
                width: "220px",
                background: ["#fff", "#646464"],
                textTransform: "uppercase",
              }}
              onClick={sendOrder}
            >
              {getLocalizedString("SEND ORDER")}
            </Button>
          </Flex>
        </Flex>
      )}
      {showSendOrderView && <SendOrderView id={orderId} />}
    </MainLayout>
  );
};

export { OrderDetailsPage };
